export interface LocaleOption {
  value: string;
  label: string;
  countryCode: string;
}

export interface CurrencyOption {
  value: string;
  label: string;
  countryCode: string;
}

export const ALL_LOCALES: LocaleOption[] = [
  { value: 'af-ZA', label: 'Afrikaans (South Africa)', countryCode: 'ZA' },
  { value: 'ar-AE', label: 'Arabic (UAE)', countryCode: 'AE' },
  { value: 'ar-EG', label: 'Arabic (Egypt)', countryCode: 'EG' },
  { value: 'ar-SA', label: 'Arabic (Saudi Arabia)', countryCode: 'SA' },
  { value: 'bg-BG', label: 'Bulgarian (Bulgaria)', countryCode: 'BG' },
  { value: 'cs-CZ', label: 'Czech (Czech Republic)', countryCode: 'CZ' },
  { value: 'da-DK', label: 'Danish (Denmark)', countryCode: 'DK' },
  { value: 'de-AT', label: 'German (Austria)', countryCode: 'AT' },
  { value: 'de-CH', label: 'German (Switzerland)', countryCode: 'CH' },
  { value: 'de-DE', label: 'German (Germany)', countryCode: 'DE' },
  { value: 'el-GR', label: 'Greek (Greece)', countryCode: 'GR' },
  { value: 'en-AU', label: 'English (Australia)', countryCode: 'AU' },
  { value: 'en-CA', label: 'English (Canada)', countryCode: 'CA' },
  { value: 'en-GB', label: 'English (United Kingdom)', countryCode: 'GB' },
  { value: 'en-IE', label: 'English (Ireland)', countryCode: 'IE' },
  { value: 'en-IN', label: 'English (India)', countryCode: 'IN' },
  { value: 'en-NZ', label: 'English (New Zealand)', countryCode: 'NZ' },
  { value: 'en-SG', label: 'English (Singapore)', countryCode: 'SG' },
  { value: 'en-US', label: 'English (United States)', countryCode: 'US' },
  { value: 'en-ZA', label: 'English (South Africa)', countryCode: 'ZA' },
  { value: 'es-AR', label: 'Spanish (Argentina)', countryCode: 'AR' },
  { value: 'es-CL', label: 'Spanish (Chile)', countryCode: 'CL' },
  { value: 'es-CO', label: 'Spanish (Colombia)', countryCode: 'CO' },
  { value: 'es-ES', label: 'Spanish (Spain)', countryCode: 'ES' },
  { value: 'es-MX', label: 'Spanish (Mexico)', countryCode: 'MX' },
  { value: 'es-PE', label: 'Spanish (Peru)', countryCode: 'PE' },
  { value: 'et-EE', label: 'Estonian (Estonia)', countryCode: 'EE' },
  { value: 'fi-FI', label: 'Finnish (Finland)', countryCode: 'FI' },
  { value: 'fr-BE', label: 'French (Belgium)', countryCode: 'BE' },
  { value: 'fr-CA', label: 'French (Canada)', countryCode: 'CA' },
  { value: 'fr-CH', label: 'French (Switzerland)', countryCode: 'CH' },
  { value: 'fr-FR', label: 'French (France)', countryCode: 'FR' },
  { value: 'he-IL', label: 'Hebrew (Israel)', countryCode: 'IL' },
  { value: 'hi-IN', label: 'Hindi (India)', countryCode: 'IN' },
  { value: 'hr-HR', label: 'Croatian (Croatia)', countryCode: 'HR' },
  { value: 'hu-HU', label: 'Hungarian (Hungary)', countryCode: 'HU' },
  { value: 'id-ID', label: 'Indonesian (Indonesia)', countryCode: 'ID' },
  { value: 'it-IT', label: 'Italian (Italy)', countryCode: 'IT' },
  { value: 'ja-JP', label: 'Japanese (Japan)', countryCode: 'JP' },
  { value: 'ko-KR', label: 'Korean (South Korea)', countryCode: 'KR' },
  { value: 'lt-LT', label: 'Lithuanian (Lithuania)', countryCode: 'LT' },
  { value: 'lv-LV', label: 'Latvian (Latvia)', countryCode: 'LV' },
  { value: 'ms-MY', label: 'Malay (Malaysia)', countryCode: 'MY' },
  { value: 'nb-NO', label: 'Norwegian (Norway)', countryCode: 'NO' },
  { value: 'nl-BE', label: 'Dutch (Belgium)', countryCode: 'BE' },
  { value: 'nl-NL', label: 'Dutch (Netherlands)', countryCode: 'NL' },
  { value: 'pl-PL', label: 'Polish (Poland)', countryCode: 'PL' },
  { value: 'pt-BR', label: 'Portuguese (Brazil)', countryCode: 'BR' },
  { value: 'pt-PT', label: 'Portuguese (Portugal)', countryCode: 'PT' },
  { value: 'ro-RO', label: 'Romanian (Romania)', countryCode: 'RO' },
  { value: 'ru-RU', label: 'Russian (Russia)', countryCode: 'RU' },
  { value: 'sk-SK', label: 'Slovak (Slovakia)', countryCode: 'SK' },
  { value: 'sl-SI', label: 'Slovenian (Slovenia)', countryCode: 'SI' },
  { value: 'sr-RS', label: 'Serbian (Serbia)', countryCode: 'RS' },
  { value: 'sv-SE', label: 'Swedish (Sweden)', countryCode: 'SE' },
  { value: 'th-TH', label: 'Thai (Thailand)', countryCode: 'TH' },
  { value: 'tr-TR', label: 'Turkish (Turkey)', countryCode: 'TR' },
  { value: 'uk-UA', label: 'Ukrainian (Ukraine)', countryCode: 'UA' },
  { value: 'vi-VN', label: 'Vietnamese (Vietnam)', countryCode: 'VN' },
  { value: 'zh-CN', label: 'Chinese Simplified (China)', countryCode: 'CN' },
  { value: 'zh-HK', label: 'Chinese Traditional (Hong Kong)', countryCode: 'HK' },
  { value: 'zh-TW', label: 'Chinese Traditional (Taiwan)', countryCode: 'TW' },
];

export const ALL_CURRENCIES: CurrencyOption[] = [
  { value: 'AED', label: 'UAE Dirham', countryCode: 'AE' },
  { value: 'ARS', label: 'Argentine Peso', countryCode: 'AR' },
  { value: 'AUD', label: 'Australian Dollar', countryCode: 'AU' },
  { value: 'BRL', label: 'Brazilian Real', countryCode: 'BR' },
  { value: 'CAD', label: 'Canadian Dollar', countryCode: 'CA' },
  { value: 'CHF', label: 'Swiss Franc', countryCode: 'CH' },
  { value: 'CLP', label: 'Chilean Peso', countryCode: 'CL' },
  { value: 'CNY', label: 'Chinese Yuan', countryCode: 'CN' },
  { value: 'COP', label: 'Colombian Peso', countryCode: 'CO' },
  { value: 'CZK', label: 'Czech Koruna', countryCode: 'CZ' },
  { value: 'DKK', label: 'Danish Krone', countryCode: 'DK' },
  { value: 'EUR', label: 'Euro', countryCode: 'EU' },
  { value: 'GBP', label: 'British Pound', countryCode: 'GB' },
  { value: 'HKD', label: 'Hong Kong Dollar', countryCode: 'HK' },
  { value: 'HUF', label: 'Hungarian Forint', countryCode: 'HU' },
  { value: 'IDR', label: 'Indonesian Rupiah', countryCode: 'ID' },
  { value: 'ILS', label: 'Israeli Shekel', countryCode: 'IL' },
  { value: 'INR', label: 'Indian Rupee', countryCode: 'IN' },
  { value: 'JPY', label: 'Japanese Yen', countryCode: 'JP' },
  { value: 'KRW', label: 'South Korean Won', countryCode: 'KR' },
  { value: 'MXN', label: 'Mexican Peso', countryCode: 'MX' },
  { value: 'MYR', label: 'Malaysian Ringgit', countryCode: 'MY' },
  { value: 'NOK', label: 'Norwegian Krone', countryCode: 'NO' },
  { value: 'NZD', label: 'New Zealand Dollar', countryCode: 'NZ' },
  { value: 'PEN', label: 'Peruvian Sol', countryCode: 'PE' },
  { value: 'PHP', label: 'Philippine Peso', countryCode: 'PH' },
  { value: 'PLN', label: 'Polish Złoty', countryCode: 'PL' },
  { value: 'RON', label: 'Romanian Leu', countryCode: 'RO' },
  { value: 'RUB', label: 'Russian Ruble', countryCode: 'RU' },
  { value: 'SAR', label: 'Saudi Riyal', countryCode: 'SA' },
  { value: 'SEK', label: 'Swedish Krona', countryCode: 'SE' },
  { value: 'SGD', label: 'Singapore Dollar', countryCode: 'SG' },
  { value: 'THB', label: 'Thai Baht', countryCode: 'TH' },
  { value: 'TRY', label: 'Turkish Lira', countryCode: 'TR' },
  { value: 'TWD', label: 'Taiwan Dollar', countryCode: 'TW' },
  { value: 'UAH', label: 'Ukrainian Hryvnia', countryCode: 'UA' },
  { value: 'USD', label: 'US Dollar', countryCode: 'US' },
  { value: 'VND', label: 'Vietnamese Dong', countryCode: 'VN' },
  { value: 'ZAR', label: 'South African Rand', countryCode: 'ZA' },
];

export const TIMEZONES = [
  { value: 'America/Toronto', label: 'Eastern — Toronto (ET)' },
  { value: 'America/New_York', label: 'Eastern — New York (ET)' },
  { value: 'America/Chicago', label: 'Central — Chicago (CT)' },
  { value: 'America/Denver', label: 'Mountain — Denver (MT)' },
  { value: 'America/Los_Angeles', label: 'Pacific — Los Angeles (PT)' },
  { value: 'America/Vancouver', label: 'Pacific — Vancouver (PT)' },
  { value: 'America/Sao_Paulo', label: 'Brasília (BRT)' },
  { value: 'Europe/London', label: 'London (GMT/BST)' },
  { value: 'Europe/Paris', label: 'Paris (CET)' },
  { value: 'UTC', label: 'UTC' },
] as const;

export const DATE_FORMATS = [
  { value: 'DD/MM/YYYY', label: 'DD/MM/YYYY', example: '31/01/2025' },
  { value: 'MM/DD/YYYY', label: 'MM/DD/YYYY', example: '01/31/2025' },
  { value: 'YYYY-MM-DD', label: 'YYYY-MM-DD', example: '2025-01-31' },
] as const;

export const TIME_FORMATS = [
  { value: '12h', label: '12-hour', example: '1:30 PM' },
  { value: '24h', label: '24-hour', example: '13:30' },
] as const;

export const NUMBER_FORMATS = [
  { value: 'en-US', label: '1,234.56', description: 'Comma thousands, dot decimal (US/CA)' },
  { value: 'de-DE', label: '1.234,56', description: 'Dot thousands, comma decimal (EU)' },
  { value: 'fr-FR', label: '1 234,56', description: 'Space thousands, comma decimal (FR)' },
] as const;
